import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { MagicTranslateService } from './app-services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private magicTranslateService = inject(MagicTranslateService);

  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIconResolver((name: string): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
      return sanitizer.bypassSecurityTrustResourceUrl(`assets/mat-icons/${name}.svg`);
    });
  }

  ngOnInit() {
    this.magicTranslateService.initLanguage().subscribe();
    const preloader = document.querySelector('.preloader');
    if (preloader && preloader.parentNode) {
      preloader.parentNode.removeChild(preloader);
    }
  }
}
